import { useMemo } from "react";
import { ColumnDescriptionDc } from "@evergis/api";

import { createLayerAttributes } from "../../../../evergis/core/attributes/createLayerAttributes";
import { AttributesUpdate, useAttributes } from "../../../../hooks/attributes/useAttributes";
import { LayerInfo } from "../../../../interfaces/resourceInfo";
import { LayerAttribute } from "../components/Layer/LayerAttributeItem";

const setClassified =
  (classifiedAttributes: string[]) =>
  <A extends ElementType<LayerInfo["layerAttributes"]>>(attribute: A) => ({
    ...attribute,
    classified: classifiedAttributes.includes(attribute.attributeName),
  });

export const useLayerAttributes = (
  {
    layerAttributes,
    layerDefinition,
    style,
  }: Partial<Pick<LayerInfo, "layerAttributes" | "style" | "layerDefinition">>,
  tableColumns: ColumnDescriptionDc[],
): [LayerAttribute[], AttributesUpdate<LayerAttribute>] => {
  const classifiedAttributes = useMemo(
    () => (style ? style.classificationManager.map(({ attribute }) => attribute) : []),
    [style],
  );

  const attributes: LayerAttribute[] = useMemo(
    () =>
      layerAttributes &&
      tableColumns &&
      createLayerAttributes(layerAttributes, tableColumns, layerDefinition).map(setClassified(classifiedAttributes)),
    [classifiedAttributes, layerAttributes, layerDefinition, tableColumns],
  );

  return useAttributes(attributes);
};
